import React from 'react';
import PropTypes from 'prop-types';

import ActionButton from '../../../shared/components/actionButton';

const ConfirmActionPanel = ({ confirmData }) => {
  return (
    <div className="confirm-panel">
      {confirmData?.message}
      <div className="buttons">
        <ActionButton
          type="button"
          title="Tak"
          className="confirm separator-right"
          onClick={() => confirmData?.onConfirm()}
        />
        <ActionButton
          type="button"
          title="Nie"
          className="cancel"
          onClick={() => confirmData?.onCancel()}
        />
      </div>
    </div>
  );
};

ConfirmActionPanel.propTypes = {
  confirmData: PropTypes.shape(),
};

ConfirmActionPanel.defaultProps = {
  confirmData: undefined,
};

export default ConfirmActionPanel;
